export const isOrHandleAsExternalUrl = (url?: string, target?: string | undefined): boolean => {
  if (!url) {
    return false;
  }

  if (target === "_top" || target === "_self") {
    return false;
  }

  if (target === "_blank") {
    return true;
  }
  // Remove leading and trailing whitespace from the URL
  url = url.trim();

  // Check if the URL starts with 'http://', 'https://', or '//'
  return (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("//") ||
    url.startsWith("mailto:") ||
    url.startsWith("tel:") ||
    url.startsWith("www")
  );
};

const epslanguageRegex = /\?epslanguage=\w{2}/;
const illegalStrings: Array<string | RegExp> = [epslanguageRegex];

/**
 * Clean url of strings that shouldn't reach frontend
 * @param url
 * @returns {string}
 */
export const cleanUrl = (url: string): string => {
  for (const illegalString of illegalStrings) {
    url = url.replace(illegalString, "");
  }
  return url;
};
